'use client'

import { useState } from 'react'
import { useRouter } from 'next/navigation'
import { SearchInputWithHistory } from '@/modules/shared/components/SearchInputWithHistory'

export default function HsDetailSearch() {
    const [searchValue, setSearchValue] = useState('')
    const [error, setError] = useState('')
    const router = useRouter()

    const handleSearch = (value: string) => {
        const trimmedValue = value.trim()

        if (!trimmedValue) {
            setError('Vui lòng nhập mã HS')
            return
        }

        if (trimmedValue.length < 4) {
            setError('Mã HS phải có ít nhất 4 ký tự')
            return
        }

        setError('')
        router.push(`/ket-qua-tra-cuu-ma-hs?q=${trimmedValue}`)
    }

    const handleChange = (value: string) => {
        setSearchValue(value)
        if (error) {
            setError('')
        }
    }

    return (
        <div className="flex items-center gap-3">
            <div className="w-[260px] relative">
                <SearchInputWithHistory
                    value={searchValue}
                    onChange={handleChange}
                    onSearch={handleSearch}
                    variant="sub-header"
                    placeholder="Tìm kiếm mã HS khác"
                    storageKey="hs-search-history"
                />
                {error && (
                    <p className="text-red-600 text-[11px] mt-1 absolute top-full right-0">
                        {error}
                    </p>
                )}
            </div>
        </div>
    )
}